/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

import * as SecureLS from 'secure-ls';
import AppConst from '../constants/app.constant';

const secureLsService = () => {
  const contents = {};
  const ls = new SecureLS({ encodingType: 'aes', encryptionSecret: AppConst.sH });
  contents.setInfo = (key, info) => {
    ls.set(AppConst.localstorageConf.prefix + key, info);
  };
  contents.getInfo = (key) => ls.get(AppConst.localstorageConf.prefix + key);
  return contents;
};
export default secureLsService();
